import { addMinutes, parseISO } from 'date-fns';

export const YYYY_MM_DD_T_HH_MM_SS_Z = "yyyy-MM-dd'T'HH:mm:ss'Z'";
export const HH_MM_REGEX = '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$';

export function utc(date: Date | string): Date {
  let dateObj: Date;
  if (typeof date === 'string') {
    dateObj = parseISO(date as string);
  } else {
    dateObj = date as Date;
  }
  return addMinutes(dateObj, dateObj.getTimezoneOffset());
}

const getSeconds = (time: number): string => {
  const seconds = Math.abs(time) % 60;
  if (seconds < 10) {
    return '0' + seconds;
  }
  return String(seconds);
};

const getMinutes = (time: number): string => {
  const minutes = Math.floor(Math.abs((Math.abs(time) % 3600) / 60));
  if (minutes < 10) {
    return '0' + minutes;
  }
  return String(minutes);
};

const getHours = (time: number): string => {
  const hours = Math.floor(Math.abs(Math.abs(time) / 3600));
  return String(hours);
};

export function formatDuration(time: number): string {
  const hours = getHours(time);
  const minutes = getMinutes(time);
  const seconds = getSeconds(time);
  const sign = time < 0 ? '-' : '';
  if (Math.abs(time) >= 3600) {
    return sign + hours + 'h ' + minutes;
  } else {
    return sign + minutes + ':' + seconds;
  }
}
